
import { NgModule }             from '@angular/core';
import { Routes,RouterModule } from '@angular/router';

import { ShareModule} from '../shared/share.module';


import { AuthGuard } from '../service/auth-guard.service';

import { AdminComponent } from './admin.component';

import { ProfileComponent } from './profile/profile.component';
import { ProfileService } from './profile/profile.service';

import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardService } from './dashboard/dashboard.service';



import { UserModule,UserRoutes } from '../module/user/user.module';
import { RoleModule,RoleRoutes } from '../module/role/role.module';
import { ProjectModule,ProjectRoutes } from '../module/project/project.module';


const modules: NgModule[] =[ShareModule,UserModule,RoleModule,ProjectModule,];
const routes: Routes =[...UserRoutes,...RoleRoutes,...ProjectRoutes,]; 
const components: Array<any> =[]; 
const services: Array<any> =[]; 


export const adminRoutes:any ={path:'admin',component:AdminComponent,children:[
          {path:'dashboard',component:DashboardComponent, canActivate: [AuthGuard], data: { "fromRoute": true,page:'admin.dashboard', operation: '_access'  }},
          {path:'profile',component:ProfileComponent, canActivate: [AuthGuard], data: { "fromRoute": true,page:'admin.profile', operation: '_access'  }},
          ...routes]}

export const adminComponents:any =[AdminComponent,ProfileComponent,DashboardComponent,...components];
export const adminServices:any =[ProfileService,DashboardService,...services];


@NgModule({
    declarations: [
    ...adminComponents
  ],
  providers: [...adminServices],
  imports: [modules, RouterModule.forChild([
      adminRoutes
      
  ]) ],
  exports: [ RouterModule,modules ]
})
export class AdminModule {}


// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts